export const NO_PERSON = { id: 'no_person', label: 'Nessuna persona presente' };
export const FATHER_OTHER_PARENT = {
  id: 'father_other_parent',
  label: 'Padre del neonato/altro genitore',
};
export const ANOTHER_FAMILY_MEMBER = {
  id: 'another_family_member',
  label: 'Altra persona di famiglia della partoriente',
};
export const ANOTHER_TRUSTED_PERSON = {
  id: 'another_trusted_person',
  label: 'Altra persona di fiducia della partoriente',
};
